import * as i18n from "util/i18n";
import * as config from "util/config";

/**
 * Default date window for transfer historic download (matches legacy TransferDownload).
 *
 * @returns {{ minDate: Date, maxDate: Date, initialDateRange: [Date, Date] }}
 */
export function getTransferDownloadDateWindow() {
    const limitMonths = config.getInteger("frontend.Transfers.maxMonths.ToSearch", 3);
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - limitMonths);
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    const endDate = new Date();
    return {
        minDate,
        maxDate: endDate,
        initialDateRange: [startDate, endDate],
    };
}

/**
 * @param {Date} date
 * @returns {string|null}
 */
export function formatTransferDownloadDateLocal(date) {
    if (!date) {
        return null;
    }

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
}

/** @typedef {"executionDate"|"download"|"downloadPdf"|"formatPdf"|"formatXls"|"formatCsv"} TransferDownloadLabelKey */

/**
 * @param {TransferDownloadLabelKey} key
 * @returns {string}
 */
export function getTransferDownloadLabels(key) {
    switch (key) {
        case "executionDate":
            return i18n.get("transfers.historic.download.executionDate");
        case "download":
            return i18n.get("global.download");
        case "downloadPdf":
            return i18n.get("transfers.historic.btn.download.pdf");
        case "formatPdf":
            return "PDF";
        case "formatXls":
            return "XLS";
        case "formatCsv":
            return "CSV";
        default:
            return key;
    }
}
